
export const environment = {
    production: true,
    basePath: 'https://api.mobilitateurbana4.ro',
    website_url: "https://www.mobilitateurbana4.ro",
    customNotifications: {
        icons: {
            success: "success",
            error: "error",
            info: "info",
            warning: "warning"
        },
        headers: {
            success: "Success",
            error: "Eroare",
            successForm: "Felicitări!",
            atention: "Atentie!"
        },
        generalMessages: {
            error: "Ne pare rău, dar am întâmpinat o problemă. Vă rugăm să reîncercați. Dacă problema persistă, vă rugăm să ne contactați prin butonul de suport IT.",
            fileErrorMsg: "Ne pare rău, dar fișierul selectat nu a putut fi încărcat. Vă rugăm să reîncercați!"
        }
    },
    routes: {
        ddru: {
            registratura: {
                formList: '/get-forms-list',
                renderForm: '/render-form',
                storeForm: '/store-form',
                uploadFile: '/upload-file'
            },
            ridicari_auto: {
                verificariAuto: '/verificare-auto',
                checkPaymentReference: '/checkRidicariAuto',
                processPaymentLink: '/processPaymentLinkRidicari'
            },
            blocari_auto: {
                checkPaymentReference: '/checkBlocariAuto',
                processPaymentLink: '/processPaymentLinkBlocari'
            },
            documente: {
                getSimboluri: '/parking/parcaje',
                checkIdentificare: '/parking/documents/check-loc-parcare',
                checkToken: '/parking/documents/check-token',
                confirmOtp: '/parking/documents/confirm-otp',
                resendOtp: '/parking/documents/resend-otp',
                downloadDocument: '/parking/documents/download'
            }
        },
        dmu: {
            platiOnline: {
                verificarePlata: '/getTaxMultiple'
            },
            tsdu: {
                interogareReferinta: '/tsdu/getTaxMultiple'
            }
        }
    }
};